import { ObjectValues } from 'helpers/types';

export const AI_ASSISTANT_ITEMS = {
  GENERATE: 'generate',
  IMPROVE: 'improve',
  SHORTER: 'shorter',
  LONGER: 'longer',
  FIX_GRAMMAR: 'fixGrammar',
} as const;

export type IAIAssistantType = ObjectValues<typeof AI_ASSISTANT_ITEMS>;

export const AI_RESPONSE_TYPES = {
  TEXT: 'text',
  COMPLEX: 'complex',
} as const;

export type IAIResponseType = ObjectValues<typeof AI_RESPONSE_TYPES>;

export type IAISavedResponse = {
  fieldName: string
  response: string
}
